// @flow
import React from "react";
import ApModal from "./ApModal.js";
import type { EditorState } from "draft-js";
import {
  replaceCurrentBlockWithAtomicBlock,
  isCurrentContentBlockBlank
} from "../utils/draftUtils.js";
import "./EmbedAssetButton.scss";

function EmbedAssetTable(props: {
  assetData: { id: number, title: string, cms_thumbnail_url: string }[],
  onEmbedClick: number => void
}) {
  return (
    <table className="embed-asset-button__table">
      <thead>
        <tr>
          <th>Thumbnail</th>
          <th>Title</th>
          <th>Embed</th>
        </tr>
      </thead>
      <tbody>
        {props.assetData.map(asset =>
          <tr key={asset.id}>
            <td><img src={asset.cms_thumbnail_url} /></td>
            <td>{asset.title}</td>
            <td>
              <button
                onClick={() => {
                  props.onEmbedClick(asset.id);
                }}
              >
                Embed
              </button>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

type Props =
  | {
      editorState: EditorState,
      onChange: EditorState => void
    }
  | any;

export default class EmbedAssetButton extends React.Component {
  state: {
    isModalOpen: boolean,
    data: any[]
  };
  props: Props;

  constructor(props: Props) {
    super(props);
    (this: any).isButtonEnabled = this.isButtonEnabled.bind(this);
    (this: any).loadData = this.loadData.bind(this);
    (this: any).onButtonClick = this.onButtonClick.bind(this);
    (this: any).onEmbedClick = this.onEmbedClick.bind(this);
    this.state = {
      isModalOpen: false,
      data: []
    };
    this.loadData();
  }

  async loadData() {
    const apObjectId = window.initial_js_data.ap_object_pk; // global
    const resp = await fetch(`/api/core/assets/?ap_object_id=${apObjectId}`, {
      credentials: "same-origin"
    });
    const data = await resp.json();
    this.setState({ data: data.results });
  }

  onButtonClick(evt: Event) {
    evt.preventDefault();
    if (this.isButtonEnabled()) {
      this.loadData();
      this.setState({ isModalOpen: true });
    }
  }

  onEmbedClick(assetId: number) {
    const { editorState } = this.props;
    const newEditorState = replaceCurrentBlockWithAtomicBlock(editorState, {
      type: "ap-asset",
      assetId
    });
    this.props.onChange(newEditorState);
    this.setState({ isModalOpen: false });
  }

  isButtonEnabled(): boolean {
    const { editorState } = this.props;
    const selectionState = editorState.getSelection();
    return (
      isCurrentContentBlockBlank(editorState) && selectionState.isCollapsed()
    );
  }

  render() {
    return (
      <div className="embed-wrapper">
        <div className="rdw-option-wrapper">
          <a
            className="embed-asset-button__button"
            onClick={this.onButtonClick}
            disabled={!this.isButtonEnabled()}
          />
          <ApModal
            isOpen={this.state.isModalOpen}
            title="Embed Asset"
            onRequestClose={() => this.setState({ isModalOpen: false })}
          >
            <EmbedAssetTable
              assetData={this.state.data}
              onEmbedClick={this.onEmbedClick}
            />
          </ApModal>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/components/EmbedAssetButton.js